import React from "react";
import { Row, Col, Typography, Dropdown, Menu, Grid, Card } from "antd";
import logo from "../assets/logo.png";
import propertyImage from "../assets/property.png";
import CommonFooter from "../components/common/CommonFooter";
import { Link } from "react-router-dom";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

export default function ListingConfirmationPage() {
  const screens = useBreakpoint();

  const menu = (
    <Menu
      theme="dark"
      style={{
        background: "rgba(0, 0, 0, 0.95)",
        color: "#fff",
        padding: screens.xs ? "8px 16px" : "10px 25px",
        borderRadius: "6px",
      }}
      items={[
        {
          key: "0",
          label: (
            <Link
              to="/"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              Home
            </Link>
          ),
        },
        {
          key: "1",
          label: (
            <Link
              to="/about-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              Who we are
            </Link>
          ),
        },
        {
          key: "2",
          label: (
            <Link
              to="/listed-property"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              Our offerings
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link
              to="/work"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              How NITM works
            </Link>
          ),
        },
        {
          key: "4",
          label: (
            <Link
              to="/policy"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              List your Property
            </Link>
          ),
        },
        {
          key: "5",
          label: (
            <Link
              to="/news-room"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              News Room
            </Link>
          ),
        },
        {
          key: "6",
          label: (
            <Link
              to="/contact-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              Contact Us
            </Link>
          ),
        },
        {
          key: "7",
          label: (
            <Link
              to="/our-story"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
            >
              Our Story
            </Link>
          ),
        },
      ]}
    />
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f0f0f0" }}>
      <Row style={{ minHeight: "100vh" }}>
        {/* Left Image Section - Hidden on mobile */}
        {screens.md ? (
          <Col md={12} style={{ position: "relative" }}>
            <img
              src={propertyImage}
              alt="Property"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "0 0 140px 0",
              }}
            />
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{ position: "absolute", top: 20, left: 20, height: 40 }}
              />
            </Link>
          </Col>
        ) : (
          // Mobile Logo - Top left on mobile
          <div style={{ position: "absolute", top: 20, left: 20, zIndex: 10 }}>
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: screens.xs ? "35px" : "40px",
                }}
              />
            </Link>
          </div>
        )}

        {/* Right Section */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#f0f0f0",
            minHeight: "100vh",
            position: "relative",
          }}
        >
          {/* Header - Smaller on mobile */}
          <div
            style={{
              width: "100%",
              background: "#DDC7BB",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: screens.xs ? "60px" : "80px",
            }}
          >
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={screens.xs ? ["click"] : ["hover"]}
            >
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#D9D9D9E5",
                  padding: screens.xs ? "0 16px" : "0 20px",
                  cursor: "pointer",
                }}
              >
                {/* Custom Hamburger Icon */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: screens.xs ? "3px" : "4px",
                    alignItems: "flex-end",
                  }}
                >
                  <span
                    style={{
                      width: screens.xs ? "20px" : "24px",
                      height: screens.xs ? "2px" : "3px",
                      background: "black",
                      borderRadius: "2px",
                    }}
                  ></span>
                  <span
                    style={{
                      width: screens.xs ? "15px" : "18px",
                      height: screens.xs ? "2px" : "3px",
                      background: "black",
                      borderRadius: "2px",
                    }}
                  ></span>
                  <span
                    style={{
                      width: screens.xs ? "10px" : "12px",
                      height: screens.xs ? "2px" : "3px",
                      background: "black",
                      borderRadius: "2px",
                    }}
                  ></span>
                </div>
              </div>
            </Dropdown>
          </div>

          {/* Confirmation Message */}
          <div
            style={{
              maxWidth: 700,
              width: "100%",
              padding: screens.xs ? "20px" : "40px",
              marginTop: screens.xs ? "20px" : "40px",
              display: "flex",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <Card
              style={{
                borderRadius: 10,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                textAlign: "center",
                padding: screens.xs ? "20px 16px" : "30px 24px",
                minHeight: screens.xs ? "auto" : "80vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: screens.xs ? "flex-start" : "center",
                width: "100%",
              }}
            >
              <Title
                level={screens.xs ? 4 : 3}
                style={{
                  color: "#000",
                  marginBottom: screens.xs ? "15px" : "20px",
                  fontSize: screens.xs ? "20px" : "24px",
                }}
              >
                Thank You!
              </Title>

              <Paragraph
                style={{
                  fontSize: screens.xs ? 14 : 16,
                  color: "#444",
                  lineHeight: 1.6,
                  textAlign: screens.xs ? "justify" : "left",
                  margin: 0,
                }}
              >
                An email confirmation for your listing has been sent to your
                registered address. We've assigned Senior Property Consultant,
                Mr. Ahmed Riaz, to personally oversee your listing. He will
                contact you shortly to verify your property details, discuss
                marketing options, and guide you through the next steps of the
                selling process.
              </Paragraph>
            </Card>
          </div>
        </Col>
      </Row>
      <CommonFooter />
    </div>
  );
}
